import { AdditionalColors } from '@gc-bridge/theme/colors';
import { BuildCircleOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface Props {
  remoteDisplayName: string;
}

export function MaintenanceMode({ remoteDisplayName }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
      }}
    >
      <BuildCircleOutlined
        fontSize="small"
        color="secondary"
        sx={{ alignSelf: 'center' }}
      />

      <Typography variant="body2" color={AdditionalColors.BlackOpacity50}>
        <strong>{remoteDisplayName}</strong> is temporarily unavailable due to
        maintenance.
      </Typography>
    </Box>
  );
}
